// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__TOkle","notFound":"NotFoundPage_notFound__qXaVf","header":"NotFoundPage_header__f1PnJ","content":"NotFoundPage_content__zYIxx"};